import { PlayerRatingScope, entryUser } from 'components/ReviewAudit/PublicRatings'
import ParticipantOption, { participantDescription } from '../../../components/ParticipantOption'
import EditorActions from 'components/Common/EditorActions'
import React, { useState, useContext } from "react"
import moment from "moment"
import { store as socketStore } from "components/Common/Socket/store"
import Slot from "../../../components/Slot"
import AddUser from "../../../../../../../../assets/images/addUser.png"
import Select from "react-select"
import { Formik, Form } from "formik"
import { createMatch, matchSendFailure, replaceMatchEntries } from "../api"

import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  FormGroup,
} from "reactstrap"

import { connect } from "react-redux"
import { getMatches } from "../actions"
import { getParticipantEntryCount } from "../../../../../../eventEntryCounts"
import { entryKeys, entrySlot, isPlaced, placedKeys } from "../../../components/participantIdentity"
import { withFloatingSurface } from 'components/Common/selectSurface'

export const AddPlayer = ({
  mainList,
  currentEvent,
  competitionDetails,
  fetchMatches,
  index,
  phaseLength,
  player,
  opponent,
  role,
  expected,
  matchId,
  matches = [],
}) => {
  const [addMatchModal, setAddMatchModal] = useState(false)
  // An existing match (it has an _id) is filled one side at a time: the side this button
  // stands on, never BYE, which cannot take an open place. A row with no match yet keeps
  // both sides and BYE, and creates the match.
  const fillRole = matchId ? role : undefined
  const byeOptions = fillRole ? [] : [{ label: "BYE", value: { type: "BYE" } }]
  const [saving, setSaving] = useState(false)

  const globalState = useContext(socketStore)
  const { state: { socket: { socketClientId } = {} } = {} } = globalState

  const formatPayloadForUpdate = data => {
    let payload = {}
    const roles = ["player", "opponent"]

    roles.forEach(roleName => {
      const roleData = data[roleName]

      // If this role (player or opponent) doesn't exist in the input, skip it
      if (!roleData) return

      if (roleData.type === "BYE") {
        payload[roleName] = { type: "BYE" }
        if (competitionDetails.gameType === "doubles") {
          payload[`${roleName}Partner`] = { type: "BYE" }
        }
      } else {
        // Standard data formatting: a Tenis10 child goes as the child (participantIdentity.js)
        payload[roleName] = entrySlot(roleData)
        if (competitionDetails.gameType === "doubles") {
          payload[`${roleName}Partner`] = roleData.partner
        }
      }
    })

    return payload
  }

  const displayConditions = player => {
    if (player?.type === "BYE") {
      return false
    } else if (player?.userId && player?.type !== "BYE") {
      return false
    } else {
      return true
    }
  }
  const showsSelect = side =>
    fillRole
      ? side === fillRole
      : displayConditions(side === "player" ? player : opponent)

  const getCompetitionRank = (playerId) => {
    let competitionRank = 0;
    matches.forEach(match => {
      if (match.player.id === playerId) {
        competitionRank = match.player.competitionRank;
      }
      if (match.opponent.id === playerId) {
        competitionRank = match.opponent.competitionRank;
      }
    });
    return competitionRank;
  };

  // Who the knockout matches already hold, by participant key: a placed child never hides its sibling (PRD 16 LR11c).
  const placed = placedKeys(matches.flat(Infinity).filter(({ competition }) => competition.drawType === "eliminatory"))
  const filteredPlayers = mainList?.filter(entry => !isPlaced(entry, placed))
  // A side's choices leave out the participant already chosen — the child chosen, never its sibling.
  const unchosen = values => {
    const taken = [values?.player, values?.opponent].map(side => entryKeys(side)[0]).filter(Boolean)
    return option => {
      const [key] = entryKeys(option)
      return !key || !taken.includes(key)
    }
  }

  return (
    <div onClick={() => setAddMatchModal(true)} className="addPlayer">
      {addMatchModal && (
        <PlayerRatingScope players={(filteredPlayers || []).flatMap(entry => [entryUser(entry), entry.partner])}><Modal scrollable isOpen={addMatchModal} toggle={() => setAddMatchModal(false)}>
          <ModalHeader toggle={() => setAddMatchModal(false)}>
            Create Match
          </ModalHeader>
          <Formik
            initialValues={{
              player: "",
              opponent: "",
            }}
          >
            {({ values, setFieldValue, status, setStatus, dirty }) => {
              return (
                <>
                  <ModalBody>
                    {status && <div role="alert" className="alert alert-danger">{status}</div>}
                    {showsSelect("player") && (
                      <>
                        <Label>Player</Label>
                        <FormGroup>
                          <Select styles={withFloatingSurface()}
                            formatOptionLabel={ParticipantOption}
                            placeholder="Player"
                            name="player"
                            options={[
                              ...byeOptions,
                              ...filteredPlayers,
                            ]
                              ?.filter(unchosen(values))
                              ?.map(player =>
                              player?.value?.type !== "BYE"
                                ? {
                                    value: player,
                                    label: [entryUser(player), player.partner].filter(Boolean).map(participantDescription).join(" / "),
                                  }
                                : {
                                    label: "BYE",
                                    value: { user: { type: "BYE" } },
                                  }
                            )}
                            onChange={({ value }) =>
                              setFieldValue("player", value)
                            }
                          />
                        </FormGroup>
                      </>
                    )}
                    {showsSelect("opponent") && (
                      <>
                        <Label>Opponent</Label>
                        <FormGroup>
                          <Select styles={withFloatingSurface()}
                            formatOptionLabel={ParticipantOption}
                            placeholder="Opponent"
                            name="opponent"
                            options={[
                              ...byeOptions,
                              ...filteredPlayers,
                            ]
                              ?.filter(unchosen(values))
                              ?.map(player =>
                              player?.value?.type !== "BYE"
                                ? {
                                    value: player,
                                    label: [entryUser(player), player.partner].filter(Boolean).map(participantDescription).join(" / "),
                                  }
                                : {
                                    label: "BYE",
                                    value: { user: { type: "BYE" } },
                                  }
                            )}
                            onChange={({ value }) =>
                              setFieldValue("opponent", value)
                            }
                          />
                        </FormGroup>
                      </>
                    )}
                  </ModalBody>

                  <ModalFooter><EditorActions dirty={dirty} pending={saving} saveLabel="Add">
                    <Button
                      color="secondary"
                      onClick={() => setAddMatchModal(false)}
                    >
                      Cancel
                    </Button>{" "}
                    <Button
                      color="primary"
                      disabled={saving || !(values?.player || values?.opponent)}
                      onClick={async () => {
                        setStatus(null)
                        setSaving(true)
                        try {
                        const { player, opponent } = values;

                        if (matchId) {
                          await replaceMatchEntries(
                            matchId,
                            competitionDetails,
                            {
                              ...formatPayloadForUpdate(values),
                              ...(expected && { expected }),
                            },
                            socketClientId
                          )
                        } else {
                          await createMatch(
                            player,
                            opponent,
                            currentEvent,
                            competitionDetails,
                            index,
                            phaseLength,
                            socketClientId
                          )
                        }

                        await fetchMatches({ competitionId: competitionDetails?._id });
                        setAddMatchModal(false)
                        } catch (error) {
                          setStatus(matchSendFailure(error, "selection is"))
                        } finally { setSaving(false) }
                      }}
                    >
                      Add
                    </Button>
                  </EditorActions></ModalFooter>
                </>
              )
            }}
          </Formik>
        </Modal></PlayerRatingScope>
      )}
      <img src={AddUser} />
      <h3>{opponent?.placeholder || player?.placeholder}</h3>
    </div>
  )
}

const Match = ({
  draw,
  className,
  competition: { position } = {},
  noOfSets,
  setModal,
  gameType,
  player = {},
  opponent = {},
  playerPartner = {},
  opponentPartner = {},
  winner,
  _id,
  scheduler,
  mainList,
  isQualification,
  index,
  eventDetails,
  addPlayer,
  competitionDetails,
  fetchMatches,
  firstStageLength,
  matchId,
  addMatchPosition,
  secondQualification,
  qualIndex,
  sortedQualifications,
  type,
  qualificationMatches,
  firstStage,
  matches,
}) => {
  const playerSlot =
    (player?.type === "PENDING" && !player.level) || player?.type === "BYE"
      ? { ...player }
      : player
  const opponentSlot =
    (player?.type === "PENDING" && !player.level) || opponent?.type === "BYE"
      ? { ...opponent }
      : opponent

  const schedulerHandler = (scheduler, isQualification, qualInfo) => {
    if (scheduler || isQualification) {
      const displayScheduler = {
        day: scheduler?.playingDay ? moment(scheduler.playingDay).format('dddd (DD.MM), ') : '',
        time: scheduler?.playingTime ? moment(scheduler.playingTime).format('[not before ]HH:mm') : '',
        court: scheduler?.court ? `${scheduler?.court}, ` : ''
      };
      return (
        <p className="text-white mb-0 p-1">
          {isQualification
            ? `Qualifying ${qualInfo?.competition?.position} | ${
                scheduler ? `${displayScheduler.day} ${displayScheduler.court} ${displayScheduler.time}` : ''
              }`
            : isQualification === undefined && `${displayScheduler.day} ${displayScheduler.court} ${displayScheduler.time}`}
        </p>
      )
    }
  }

  // A slot's own entries in the event: a Tenis10 child's by its profileId (PRD 16 LR11c).
  const getCurrentPlayerEntries = person =>
    person?.userId == null ? 0 : getParticipantEntryCount(eventDetails, person)

  const getqualificationMatchIdentifier = (qualificationMatch, nextStage) => {
    return qualificationMatch?.competition?.position;

    for (let i = 0; i < sortedQualifications?.length; i++) {
      if (sortedQualifications[i] == qualificationMatch) {
        if (nextStage) {
          return i + 2
        } else {
          return i + 1
        }
      }
    }
  }

  let currentQualMatches = qualificationMatches?.filter(
    y =>
      y?.competition?.nextStagePosition === position * 2 ||
      y?.competition?.nextStagePosition === position * 2 - 1
  )

  return (
    <>
      {/* Qualification matches */}
      {currentQualMatches
        ?.sort((a, b) => b?.competition?.position - a?.competition?.position)
        ?.map((qualInfo, idx) => {
          const {
            player,
            competition,
            playerPartner,
            opponent,
            opponentPartner,
            winner,
            _id,
          } = qualInfo

          const matchId = _id

          return firstStage ? (
            <div
              className={`Match ${
                currentQualMatches?.length > 1 && idx === 0
                  ? "firstQualMatch"
                  : "secondQualMatch"
              } qualMatch ${
                (secondQualification &&
                  qualIndex === 0 &&
                  "multipleQualificationsFirstMatch ") ||
                (secondQualification &&
                  qualIndex === 1 &&
                  "multipleQualificationsSecondMatch ")
              } ${className}`}
            >
              <span className="position">
                {isQualification ? getqualificationMatchIdentifier(qualInfo) : (position || addMatchPosition || index + 1)}
              </span>
              <div className="Match__content">
                {/* display court details */}
                {schedulerHandler(scheduler, isQualification, qualInfo)}
                <div className="flex align-items-center">
                  <Slot
                    partnerId={playerPartner?.userId}
                    matchId={matchId}
                    competitionDetails={competitionDetails}
                    winner={winner === "player"}
                    bye={winner === "BYE"}
                    user={player}
                    seeded={player?.seeded}
                    competitionPosition={player?.competitionRank}
                    partner={playerPartner?.level && playerPartner}
                    mainList={mainList}
                    replacePlayer={true}
                    gameType={gameType}
                    draw={draw}
                    playerEntries={getCurrentPlayerEntries(player)}
                    partnerEntries={getCurrentPlayerEntries(playerPartner)}
                    fetchMatches={fetchMatches}
                    role="player"
                    competitionId={competitionDetails?._id}
                    matches={matches}
                  />
                  {!addPlayer && (
                    <div className="d-flex flex-column">
                      <div className="score flex">
                        {new Array(noOfSets).fill().map((el, index) => {
                          const [score] = (player.score || []).filter(
                            ({ set }) => set === index + 1
                          )
                          return (
                            <div>
                              <div>
                                <span>{(score && score.points) || 0}</span>
                              </div>
                              {score && score.tie && (
                                <span className="tie">
                                  {score && score.tie}
                                </span>
                              )}
                            </div>
                          )
                        })}
                        {player?.reason === "ABANDONED" ? "Ab." : ""}
                      </div>
                      <p className="text-white m-auto mb-0">
                        {player?.reason === "NO_SHOW" && "WO"}
                      </p>
                    </div>
                  )}
                </div>
                {/* opponent */}
                <div className="flex align-items-center">
                  {
                    <Slot
                      competitionDetails={competitionDetails}
                      partnerId={opponentPartner?.userId}
                      winner={winner === "opponent"}
                      partner={opponentPartner?.level && opponentPartner}
                      bye={winner === "BYE"}
                      seeded={opponent?.seeded}
                      competitionPosition={opponent?.competitionRank}
                      user={opponent}
                      mainList={mainList}
                      replacePlayer={true}
                      gameType={gameType}
                      draw={draw}
                      playerEntries={getCurrentPlayerEntries(opponent)}
                      partnerEntries={getCurrentPlayerEntries(opponentPartner)}
                      fetchMatches={fetchMatches}
                      matchId={matchId}
                      role="opponent"
                      competitionId={competitionDetails?._id}
                      matches={matches}
                    />
                  }

                  {!addPlayer && (
                    <div className="d-flex flex-column">
                      <div className="score flex">
                        {new Array(noOfSets).fill().map((el, index) => {
                          const [score] = (opponent.score || []).filter(
                            ({ set }) => set === index + 1
                          )
                          return (
                            <div>
                              <div>
                                <span>{(score && score.points) || 0}</span>
                              </div>
                              {score && score.tie && (
                                <span className="tie">
                                  {score && score.tie}
                                </span>
                              )}
                            </div>
                          )
                        })}
                        {opponent?.reason === "ABANDONED" ? "Ab." : ""}
                      </div>{" "}
                      <p className="text-white m-auto mb-0">
                        {opponent?.reason === "NO_SHOW" && "WO"}
                      </p>
                    </div>
                  )}
                </div>
              </div>
              {/* {!addPlayer && ( */}
              <span
                onClick={() => setModal(_id)}
                className={`settings ${addPlayer && "disabledSettings"}`}
              >
                <i className="bx bxs-cog" />
              </span>
              {/* )} */}
            </div>
          ) : (
            ""
          )
        })}

      {/* match */}
      <div
        className={`Match ${
          (secondQualification &&
            qualIndex === 0 &&
            "multipleQualificationsFirstMatch ") ||
          (secondQualification &&
            qualIndex === 1 &&
            "multipleQualificationsSecondMatch ")
        } ${className}`}
      >
        <span className="position">
          {position ? position : addMatchPosition || index + 1}
        </span>
        {type === "TBA" ? (
          <div className="tbaMatch">
            <h1>TBA</h1>
          </div>
        ) : (
          <div className="Match__content">
            {/* display court details */}
            {schedulerHandler(scheduler)}
            <div className="flex align-items-center">
              {/* -CREATE MATCH COMPONENT- */}
              {addPlayer ? (
                <AddPlayer
                  competitionDetails={competitionDetails}
                  currentEvent={eventDetails}
                  mainList={mainList}
                  fetchMatches={fetchMatches}
                  index={index}
                  phaseLength={firstStageLength}
                  player={player}
                  matchId={matchId}
                  matches={matches}
                />
              ) : (
                // player
                <>
                  {!player?.userId &&
                  player?.type !== "BYE" &&
                  player?.type !== "PENDING" ? (
                    <AddPlayer
                      competitionDetails={competitionDetails}
                      currentEvent={eventDetails}
                      mainList={mainList}
                      fetchMatches={fetchMatches}
                      index={index}
                      phaseLength={firstStageLength}
                      player={player}
                      matchId={matchId}
                      matches={matches}
                    />
                  ) : (
                    <Slot
                      qualPlayerNumber={getqualificationMatchIdentifier(
                        currentQualMatches?.length > 0 &&
                          currentQualMatches?.sort(
                            (a, b) =>
                              a?.competition?.position -
                              b?.competition?.position
                          )[0]
                      )}
                      partnerId={playerPartner?.userId}
                      matchId={matchId}
                      competitionDetails={competitionDetails}
                      winner={winner === "player"}
                      bye={winner === "BYE"}
                      user={playerSlot}
                      seeded={player?.seeded || (competitionDetails?.drawModel === 'groups' && player?.competitionRank <= competitionDetails?.numberOfGroups)}
                      competitionPosition={player?.competitionRank}
                      partner={playerPartner?.level && playerPartner}
                      mainList={mainList}
                      replacePlayer={true}
                      gameType={gameType}
                      draw={draw}
                      playerEntries={getCurrentPlayerEntries(playerSlot)}
                      partnerEntries={getCurrentPlayerEntries(playerPartner)}
                      fetchMatches={fetchMatches}
                      role="player"
                      competitionId={competitionDetails?._id}
                      matches={matches}
                    />
                  )}
                </>
              )}
              {!addPlayer && (
                <div className="d-flex flex-column">
                  <div className="score flex">
                    {new Array(noOfSets).fill().map((el, index) => {
                      const [score] = (player.score || []).filter(
                        ({ set }) => set === index + 1
                      )
                      return (
                        <div>
                          <div>
                            <span>{(score && score.points) || 0}</span>
                          </div>
                          {score && score.tie && (
                            <span className="tie">{score && score.tie}</span>
                          )}
                        </div>
                      )
                    })}
                    {player?.reason === "ABANDONED" ? "Ab." : ""}
                  </div>
                  <p className="text-white m-auto mb-0">
                    {player?.reason === "NO_SHOW" && "WO"}
                  </p>
                </div>
              )}
            </div>
            {/* opponent */}
            <div className="flex align-items-center">
              {addPlayer ? (
                <AddPlayer
                  competitionDetails={competitionDetails}
                  currentEvent={eventDetails}
                  mainList={mainList}
                  fetchMatches={fetchMatches}
                  index={index}
                  phaseLength={firstStageLength}
                  opponent={opponent}
                  matchId={matchId}
                  matches={matches}
                />
              ) : (
                <>
                  {!opponent?.userId &&
                  opponent?.type !== "BYE" &&
                  opponent?.type !== "PENDING" ? (
                    <AddPlayer
                      competitionDetails={competitionDetails}
                      currentEvent={eventDetails}
                      mainList={mainList}
                      fetchMatches={fetchMatches}
                      index={index}
                      phaseLength={firstStageLength}
                      opponent={opponent}
                      matchId={matchId}
                      matches={matches}
                    />
                  ) : (
                    <Slot
                      qualPlayerNumber={getqualificationMatchIdentifier(
                        currentQualMatches?.length > 0 &&
                          currentQualMatches?.sort(
                            (a, b) =>
                              a?.competition?.position -
                              b?.competition?.position
                          )[0],
                        currentQualMatches?.length > 0 && "nextStage"
                      )}
                      competitionDetails={competitionDetails}
                      partnerId={opponentPartner?.userId}
                      winner={winner === "opponent"}
                      partner={opponentPartner?.level && opponentPartner}
                      bye={winner === "BYE"}
                      seeded={opponent?.seeded || (competitionDetails?.drawModel === 'groups' && opponent?.competitionRank <= competitionDetails?.numberOfGroups)}
                      competitionPosition={opponent?.competitionRank}
                      user={opponentSlot}
                      mainList={mainList}
                      replacePlayer={true}
                      gameType={gameType}
                      draw={draw}
                      playerEntries={getCurrentPlayerEntries(opponentSlot)}
                      partnerEntries={getCurrentPlayerEntries(opponentPartner)}
                      fetchMatches={fetchMatches}
                      matchId={matchId}
                      role="opponent"
                      competitionId={competitionDetails?._id}
                      matches={matches}
                    />
                  )}
                </>
              )}

              {!addPlayer && (
                <div className="d-flex flex-column">
                  <div className="score flex">
                    {new Array(noOfSets).fill().map((el, index) => {
                      const [score] = (opponent.score || []).filter(
                        ({ set }) => set === index + 1
                      )
                      return (
                        <div>
                          <div>
                            <span>{(score && score.points) || 0}</span>
                          </div>
                          {score && score.tie && (
                            <span className="tie">{score && score.tie}</span>
                          )}
                        </div>
                      )
                    })}
                    {opponent?.reason === "ABANDONED" ? "Ab." : ""}
                  </div>{" "}
                  <p className="text-white m-auto mb-0">
                    {opponent?.reason === "NO_SHOW" && "WO"}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* {!addPlayer && ( */}
        <span
          onClick={() => setModal(_id)}
          className={`settings ${addPlayer && "disabledSettings"}`}
        >
          <i className="bx bxs-cog" />
        </span>
        {/* )} */}
      </div>
    </>
  )
}

const mapStateToProps = ({
  matches: {
    matches = [],
  } = {},
}) => ({
  matches,
})

export default connect(mapStateToProps, { fetchMatches: getMatches })(Match)
